module.exports = __webpack_public_path__ + "img/v1-roadshows.540957b8.png";